import React, { useEffect, useRef, useState } from 'react';
import ShellIcon from './ShellIcon';

export default function VideoVolumeControl({ muted, volume, onVolumeChange, onToggleMute }: {
  muted: boolean; volume: number; onVolumeChange: (volume: number) => void; onToggleMute: () => void;
}) {
  const [open, setOpen] = useState(false);
  const container = useRef<HTMLDivElement>(null);
  const button = useRef<HTMLButtonElement>(null);
  const percent = Math.round((muted ? 0 : volume) * 100);
  useEffect(() => {
    if (!open) return;
    container.current?.querySelector<HTMLInputElement>('input[type="range"]')?.focus();
    const dismiss = (event: PointerEvent) => { if (!container.current?.contains(event.target as Node)) setOpen(false); };
    document.addEventListener('pointerdown', dismiss);
    return () => document.removeEventListener('pointerdown', dismiss);
  }, [open]);
  return <div className="feed-volume-control" ref={container} onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget as Node)) setOpen(false);
  }} onClick={event => event.stopPropagation()} onKeyDown={event => {
    event.stopPropagation();
    if (event.key === 'Escape') { setOpen(false); button.current?.focus(); }
  }}>
    {open && <div className="feed-volume-popover" role="group" aria-label="Volume controls">
      <output>{percent}%</output>
      <input type="range" min="0" max="1" step="0.05" value={muted ? 0 : volume} aria-label="Video volume" onChange={event => onVolumeChange(Number(event.target.value))} />
      <button type="button" aria-label={muted ? 'Unmute video' : 'Mute video'} onClick={onToggleMute}><ShellIcon name={muted || !volume ? 'muted' : 'volume'} size={16} /></button>
    </div>}
    <button type="button" className="feed-volume-trigger" ref={button} aria-label="Adjust video volume" aria-expanded={open} onClick={() => setOpen(value => !value)}><ShellIcon name={muted || !volume ? 'muted' : 'volume'} size={17} /></button>
  </div>;
}
